import { render, staticRenderFns } from "./pelamar.vue?vue&type=template&id=db761436"
import script from "./pelamar.vue?vue&type=script&lang=js"
export * from "./pelamar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports